const DEFAULT_HOST = "shebaa247.com";
const DEV_SERVER_IP = "76.13.212.252";
const CURRENCY = "£"; // Default currency symbol

// Application Configuration
export {
  APP_INFO,
  APP_SETTINGS,
  type AppLanguage,
  type AppTheme,
  type TimeFormat,
} from "./app";

// Environment Configuration
export {
  ENV,
  isDevelopment,
  isProduction,
  isTest,
  type NodeEnv,
} from "./environment";

export { CURRENCY, DEFAULT_HOST, DEV_SERVER_IP };
